export default "__VITE_ASSET__08c3288e__"